/**
 * Created by mykurisu on 2018/4/2.
 */
import React from 'react'
import {isPC} from '../../utils'
import '../../css/page/MainPage.css';


class MainIntroSlider extends React.Component {


    handleEnter(id, type) {
        window._czc && window._czc.push(['_trackEvent', 'specials', `main_intro_slider`, `${id}`, 1])
        if (type === 'channel') {
            window.location = `/channel/${id}?inviter_id=52439352&fr=big_intro&st=lzwk_inside`
        } else {
            window.location = `/lecture/${id}?inviter_id=52439352&fr=big_intro&st=lzwk_inside`
        }
    }

    render() {
        if (!this.props.list) {
            return null
        }
        if (this.props.list && this.props.list.length < 3) {
            return null
        }
        return(
            <div>
                <div className="main__introslider-title">
                    <p>大咖课堂</p>
                </div>
                <div className="main__introslider">
                    <div className="main__introslider-container" style={{height: isPC() ? '164px' : '174px'}}>
                        <div className="introslider__wrap" style={{height: isPC() ? '164px' : '174px'}}>
                            {this.props.list && this.props.list.map(item => (
                                <div key={item.id} className="wrap__item" onClick={() => this.handleEnter(item.id, item.type)}>
                                    <div className="item__banner" style={{backgroundImage: `url(${item.cover})`}}>

                                    </div>
                                    <div className="item__title">
                                        {item.name}
                                    </div>
                                    <div className="item__num">
                                        <span>{item.popular >= 10000 ? (item.popular / 10000).toFixed(2) + '万+' : item.popular }</span><span>人气</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MainIntroSlider



// WEBPACK FOOTER //
// ./src/components/main/MainIntroSlider.js